import {createAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {strategies} from '../../services/apiService'

export const strategiesSlice = createSlice({
    name: 'strategies',
    initialState: {
        loading : false,
        strategies: [],
        pagination : {
            showSizeChanger:false,
            total: 0,
            pageSize: 20,
            current: 0
        }
    },
    reducers: {
        updatePagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadStrategies.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(loadStrategies.fulfilled, (state, action) => {
                const {content: strategies = [], pageable: page, totalElements} = action.payload;
                const pagination = {
                    total: totalElements,
                    pageSize: page.pageSize,
                    current: page.pageNumber + 1
                };
                state.strategies = strategies;
                state.pagination = pagination;
                state.loading = false;
            })
            .addCase(loadStrategies.rejected, (state, action) => {
                state.strategies = [];
                state.loading = false;
            })
    }
})

export const { updatePagination } = strategiesSlice.actions;

export const loadStrategies = createAsyncThunk('strategies/loadStrategies', ({pagination, sorting}) => {
    return strategies(pagination, sorting);
})

export default strategiesSlice.reducer

